import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { Classification } from './classification'

export class ClassificationsRepository extends BaseRepository<Classification> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.financialApiUrl + '/classifications', token, cache)
    }
}
